// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PageFaq{margin-bottom:3rem}.PageFaq>.Title{text-transform:uppercase}.PageFaq__menu{position:sticky;top:.5rem}.PageFaq__menuLink{color:#7cb342;font-size:.8125rem;-webkit-text-decoration:underline;text-decoration:underline}.PageFaq__menuLink:focus,.PageFaq__menuLink:hover{-webkit-text-decoration:none;text-decoration:none}.PageFaq__menuLink:active,.PageFaq__menuLink:focus{color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
